import type { App } from 'vue'

export const setupApp = async (app?: App) => {
  try {
    const baseUrl = import.meta.env.VITE_CDN_URL ? import.meta.env.VITE_CDN_URL : ''

    const response = await fetch(baseUrl + '/version.txt', { cache: 'no-store' })
    const latestVersion = await response.text()
    const currentVersion = localStorage.getItem('app-version')

    if (latestVersion && currentVersion !== latestVersion) {
      localStorage.setItem('app-version', latestVersion)
      window.location.reload()
    } else {
      app?.mount('#app')
    }
  } catch {
    app?.mount('#app')
  }
}
